/**
* @version GENERATOR_VERSION::20200422
* @DateTime 2020-04-29T08:55:39.227
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getHouseCycleDetailEditInit,
	getHouseCycleDetailView
} from '@api/house/HouseCycleDetail';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef';

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary)
	},

	actions: {
		getHouseCycleDetailEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getHouseCycleDetailEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getHouseCycleDetailView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getHouseCycleDetailView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
